// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2I6_u","col":"CardReaderDesc_col__2jfym","label":"CardReaderDesc_label__3cLoN"};